<template>
    <div>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
		    <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
		    <img src="../../../assets/images/pop/ld/ld.png" class="steps step1" v-if="status==1">
		    <div class="stepbtn" @click="nextStep(status)">
		        {{status==1?"我知道了":"我知道了"}}
		    </div>
		    <div class="bottomTip">
		        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
		    </div>
		</div>
<!--        <breadcrumb :routerList="[{to:'/loud/loud',title:'信息漏斗分析'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="　　最后更新时间" class="ljjstylepicker" style="width: 50%;">
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.ldateBegin"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.ldateEnd"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item label="区域">
							    <brselect
							            style="width:100%;"
							            clearable
							            category="YLRegion"
							            :v="formInline.area"
							            v-model="formInline.area"
							            placeholder="--请选择--">
							    </brselect>
							</el-form-item>
							<el-form-item label="渠道">
							    <brselect
							            style="width:100%;;"
							            category="loud_region"
							            :v="formInline.customerChannel"
							            v-model="formInline.customerChannel"
							            clearable
							            placeholder="--请选择--">
							    </brselect>
							</el-form-item>
						</div>	
                       
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="报单日期" class="ljjstylepicker" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.expectConvertDateBegin"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.expectConvertDateEnd"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="链群">
									    <brselect
									            style="width:100%;"
									            category="gh_lianqun"
									            :v="formInline.chainGroup"
									            v-model="formInline.chainGroup"
									            clearable
									            placeholder="--请选择--">
									    </brselect>
									</el-form-item>
									<el-form-item label="产品型号">
									    <el-input
									            v-model="formInline.productModel"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="　　预计成单时间" class="ljjstylepicker" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.expConvDateBegin"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.expConvDateEnd"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="项目名称">
									    <el-input
									            v-model="formInline.projectName"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
									<el-form-item label="　　是否城市网">
										<brselect
												style="width:100%;"
												category="chengshi_wang"
												:v="formInline.whetherContactor"
												v-model="formInline.whetherContactor"
												clearable
												placeholder="--请选择--">
										</brselect>
									</el-form-item>
								</div>	
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="项目进展">
									    <el-input
									            v-model="formInline.remark"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
									<el-form-item label="节点">
										<brselect category="xinxi_jiedian"
										          :v="formInline.statusR"
										          :multiple="true"
										          clearable
										          style="width:100%;"
										          v-model="formInline.statusR">
										</brselect>
									</el-form-item>
									<el-form-item label="合伙人">
										<el-input
												v-model="formInline.partner"
												placeholder="请输入"
												clearable>
										</el-input>
									</el-form-item>
									<el-form-item label="信息类别">
										<brselect
												style="width:100%;"
												category="message_type"
												:v="formInline.messageType"
												v-model="formInline.messageType"
												clearable
												placeholder="--请选择--">
										</brselect>
									</el-form-item>
								</div>	
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="　中/丢标品牌">
										<el-input
												v-model="formInline.dbBrand"
												placeholder="请输入"
												clearable>
										</el-input>
									</el-form-item>
									<el-form-item label="　跟单商类别">
										<brselect
												style="width:100%;"
												category="gendanshang"
												:v="formInline.merchandier"
												v-model="formInline.merchandier"
												clearable
												placeholder="--请选择--">
										</brselect>
									</el-form-item>
									<el-form-item label="　　是否挂网补录">
										<brselect
												style="width:100%;"
												category="shifou_keyong"
												:v="formInline.supplement"
												v-model="formInline.supplement"
												clearable
												placeholder="--请选择--">
										</brselect>
									</el-form-item>
									<el-form-item label="用户单位">
									    <el-input
									            v-model="formInline.customerName"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn smTabless" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
                            @selection-change="handleSelectionChange"
							max-height="540"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选">
                        </el-table-column>
                        <!--@cell-mouse-enter="tablemouseenter"
                        @cell-mouse-leave="tablemouseleave"-->
                        <el-table-column
						fixed
                                type="index"
                                width="40"
                                label="#"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="area"
                                width="120"
                                label="区域"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode == scope.row.cucode || a == 1"
                                          category="YLRegion" :v="scope.row.area"
                                          v-model="scope.row.area"
                                          @change="changejiedian('area',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="YLRegion" :v="scope.row.area" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="customerChannel"
                                width="120"
                                label="渠道"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode == scope.row.cucode || a == 1"
                                          category="loud_region" :v="scope.row.customerChannel"
                                          v-model="scope.row.customerChannel"
                                          @change="changejiedian('customerChannel',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="loud_region" :v="scope.row.customerChannel" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="projectName"
                                width="180"
                                label="项目名称"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                          v-model="scope.row.projectName"
                                          placeholder="项目名称"
                                          @change="changejiedian('projectName',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.projectName}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="customerName"
                                width="180"
                                label="用户单位"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                          v-model="scope.row.customerName"
                                          placeholder="用户单位"
                                          @change="changejiedian('customerName',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.customerName}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chainGroup"
                                width="100"
                                label="链群"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode == scope.row.cucode || a == 1"
                                          category="gh_lianqun" :v="scope.row.chainGroup"
                                          v-model="scope.row.chainGroup"
                                          @change="changejiedian('chainGroup',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="gh_lianqun" :v="scope.row.chainGroup" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="产品信息">
                            <el-table-column
                                    prop="productModel"
                                    width="140"
                                    label="产品型号"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                              v-model="scope.row.productModel"
                                              placeholder="产品型号"
                                              @change="changejiedian('productModel',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.productModel}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="num"
                                    width="80"
                                    label="数量"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                              v-model="scope.row.num"
                                              placeholder="数量"
                                              @change="changejiedian('num',scope.row)"
                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.num}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="price"
                                    width="100"
                                    label="价格(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                              v-model="scope.row.price"
                                              placeholder="价格"
                                              @blur="changenums(scope.row)"
                                              @change="changeNum('price',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.price}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="totalValue"
                                    width="100"
                                    label="合计(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{ scope.row.totalValue }}</div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="statusR"
                                width="170"
                                label="节点"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode == scope.row.cucode || a == 1"
                                          category="xinxi_jiedian" :v="scope.row.statusR" v-model="scope.row.statusR"
                                          @change="changejiedian('statusR',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <!--  改颜色用的    :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"-->
                                <dictname v-else category="xinxi_jiedian" :v="scope.row.statusR" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                width="160"
                                label="项目进展"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="a == 1"
                                          v-model="scope.row.remark"
                                          placeholder="备注信息"
                                          @change="changejiedian('remark',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.remark}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="ldate"
                                width="160"
                                label="最后更新时间"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">
                                    {{scope.row.ldate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="expectConvertDate"
                                width="100"
                                label="报单日期"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.expectConvertDate}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="expConvDate"
                                width="180"
                                label="预计成单日期">
                            <template slot-scope="scope">
                                <el-date-picker
										style="width: 100%;"
                                        v-if="_user.usercode == scope.row.cucode || a == 1"
                                        v-model="scope.row.expConvDate"
                                        type="date"
                                        @change="changejiedian('expConvDate',scope.row)"
                                        :clearable="false"
                                        class="h-tableInput"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="scope.row.expConvDate"
                                        placeholder="请选择日期"
                                        :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">
                                </el-date-picker>
                                <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.expConvDate}}</div>
                            </template>
                        </el-table-column>



                        <el-table-column
                                prop="partner"
                                width="200"
                                label="合伙人名称"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                          v-model="scope.row.partner"
                                          placeholder="合伙人(客户或者个人)"
                                          @change="changejiedian('partner',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.partner}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="用户信息">
                            <el-table-column
                                    prop="deptName"
                                    width="100"
                                    label="部门/科室"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                              v-model="scope.row.deptName"
                                              placeholder="部门/科室"
                                              @change="changejiedian('deptName',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.deptName}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="chargePerson"
                                    width="100"
                                    label="负责人"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                              v-model="scope.row.chargePerson"
                                              placeholder="负责人"
                                              @change="changejiedian('chargePerson',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.chargePerson}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="phone"
                                    width="160"
                                    label="电话"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode == scope.row.cucode || a == 1"
                                              v-model="scope.row.phone"
                                              placeholder="电话"
                                              @change="changejiedian('phone',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.phone}}</div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="中/丢标分析" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="dbBrand"
                                    width="150"
                                    label="中标品牌"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode || a == 1"
                                              v-model="scope.row.dbBrand"
                                              placeholder="中标品牌"
                                              @change="changejiedian('dbBrand',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.dbBrand}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dbTotalValue"
                                    width="160"
                                    label="中/丢标总额(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode || a == 1"
                                              v-model="scope.row.dbTotalValue" placeholder="0"
                                              class="h-tableInput"
                                              @change="changejiedian('dbTotalValue',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.dbTotalValue}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dbReason"
                                    width="150"
                                    label="丢标原因"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode || a == 1"
                                              v-model="scope.row.dbReason"
                                              placeholder="丢标原因"
                                              @change="changejiedian('dbReason',scope.row)"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']">{{scope.row.dbReason}}</div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="merchandier"
                                width="130"
                                label="跟单商类别"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode ==  scope.row.cucode || a == 1"
                                          category="gendanshang" :v="scope.row.merchandier"
                                          v-model="scope.row.merchandier"
                                          @change="changejiedian('merchandier',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="gendanshang" :v="scope.row.merchandier" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="supplement"
                                width="130"
                                label="是否挂网补录"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode ==  scope.row.cucode || a == 1"
                                          category="shifou_keyong" :v="scope.row.supplement"
                                          v-model="scope.row.supplement"
                                          @change="changejiedian('supplement',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="shifou_keyong" :v="scope.row.supplement" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="whetherContactor"
                                width="120"
                                label="是否城市网"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode ==  scope.row.cucode || a == 1"
                                          category="chengshi_wang" :v="scope.row.whetherContactor"
                                          v-model="scope.row.whetherContactor"
                                          @change="changejiedian('whetherContactor',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="chengshi_wang" :v="scope.row.whetherContactor" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="messageType"
                                width="130"
                                label="信息类别"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode == scope.row.cucode || a == 1"
                                          category="message_type" :v="scope.row.messageType"
                                          v-model="scope.row.messageType"
                                          @change="changejiedian('messageType',scope.row)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="message_type" :v="scope.row.messageType" :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':(scope.row.color == 6)?'yhtabGreen':'']" style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="false" prop="color">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="140">
                            <template slot-scope="scope">
                                <el-button style="color: 1C84C6;" @click="showHistory(scope.row)" type="text">操作记录</el-button>
                                <el-button style="color: 1C84C6;" v-if="_user.usercode ==  scope.row.cucode || a == 1" @click="handleClickdel(scope.$index, tableData, scope.row)" type="text">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL" v-auth="'plldan'">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ"  icon="h-el-icon h-el-icon-lsjl"
                               @click="showQBHistory(2)">操作记录
                    </el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="loudXinImportExcel"
                                     :startrow="4" :extparams="bd" @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="handleFanye"/>
                </div>
            </div>
        </div>
<!--        <div class="h-txtCenter h-mrt60" style="margin: 1rem auto 0 auto;" v-auth="'ldan'">-->
        <div class="h-txtCenter h-mrt60" style="margin: 1rem auto 0 auto;">
            <!-- <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button> -->
            <!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveTo">保存</el-button>-->
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="subTo">提交</el-button>
        </div>
        <el-dialog
                title=""
                :visible.sync="dialogVisible"
                :fullscreen="false"
                width="50%"
                :modal="true"
                :before-close="handleClose">
            <div class="h-formbLine yhelformitem" style="margin-bottom: 0.1rem;display: flex;align-items: center;">
                <el-form :inline="true" :model="mf" class="demo-form-inline h-formBorder">
                    <el-form-item label="更新节点">
                        <brselect
                                category="loud_node"
                                :v="mf.changeNode"
                                v-model="mf.changeNode"
                                clearable>
                        </brselect>
                    </el-form-item>
                    <el-form-item label="预测单号" v-if="false">
                        <el-input v-model="q.loudId"></el-input>
                    </el-form-item>
                    <el-form-item label="标识" v-if="false">
                        <el-input v-model="q.del"></el-input>
                    </el-form-item>
                   <!-- <el-form-item class="h-formBtnOut" style="margin-top:-11px;width:40%;">

                    </el-form-item> -->
                </el-form>
				<div style="margin-top: -0.2rem;margin-left: 0.2rem;">
					<el-button class="h-btn h-formBtn" @click="handleMessage">搜索</el-button>
					<el-button class="h-btn h-formBtn" @click="resetMsg"
					           style="background-color:white;color:black;border:1px solid #d1d1d1">重置
					</el-button>
				</div>
            </div>
            <div class="tanBox">
                <el-table
                        :data="tableDatas"
						border
						max-height="420"
                        style="width: 100%">
                    <el-table-column
                            type="index"
							width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="loudId"
                            label="漏斗id"
                            width="200"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="changeNode"
                            label="更新节点"
                            width="140"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="loud_node" :v="scope.row.changeNode"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="更新人员"
                            width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="changeTime"
                            label="更新时间"
                            width="200"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="changeMessage"
                            label="更新内容"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table>
            </div>
            <div style="display:flex;justify-content: space-between;align-items:center;margin-top:20px">
				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
				           @click="exportMsgExcel">批量导出
				</el-button>
                <paginationmin :page="mf" @query="handleMessage"/>
            </div>
        </el-dialog>
    </div>
</template>
<script>

    import big from 'big.js'
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    export default {
        components: {
            uploaddownexcel,
        },
        name: 'leftMenu',
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                dialogVisible:false,
                tableDatas:[],
                multipleSelection: [],
				toshow:"loud_xin",
                timeValue1: '',
                timeValue2: '',
                timeValue3: '',
				showOrhide:false,
				status:1,
				checked:true,
                // shifoukeyonglist:[],
                uploaddownexcelflag: false,
                showArea: false,
                a: '',
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    idlist: []
                },
                tableData: [],
                userRole: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                mf: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                // show:false,
                moreCondition: false,
            }
        },
        mounted() {

        },
        created() {
			// 遮罩
			this.showzhezhao()
            // this.shifoukeyonglist = this.$store.getters.dictlist("shifou_keyong");
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            exportMsgExcel() {
                var idlist=[];
                idlist.push(this.mf.del)
                idlist.push(this.mf.loudId)
                if (idlist.length < 2) {
                    this.$msg.msg("无可导出数据! ");
                } else {
                    updownfile.down("/api/swyl/v1/demo/loudChangeMsg/downloadExcel",idlist,"post",'data');
                }
            },
            resetMsg() {
                this.mf.changeNode = '';
                this.mf.pageSize = 10;
                this.mf.pageNo = 1;
                this.handleMessage();
            },
            handleMessage() {
                ss.loud.showHistory(this.mf).then(rd => {
                    this.mf.total = rd.total;
                    this.tableDatas = rd.records;
                })
            },
			changenums(v){
				if(/^[+-]?(0|([1-9]\d*))(\.\d+)?$/.test(v.price) == false){
					this.$msg.msge('请输入正确的小数或数字')
					v.price = ''
				} else {
                    v.totalValue = new big(v.num).times(v.price)
                }

			},
            showHistory(v){
                var m = {
                    pageSize: 10,
                    pageNo: 1,
                    loudId: v.id,
                    del: 1
                }
                ss.loud.showHistory(m).then(rd => {
                    this.mf.total = rd.total;
                    this.tableDatas = rd.records;
                    this.mf.loudId = v.id;
                    this.mf.del = 1;
                    this.dialogVisible = true;
                })
            },
            showQBHistory(d) {
                var m = {
                    pageSize: 10,
                    pageNo: 1,
                    del: d
                }
                ss.loud.showHistory(m).then(rd => {
                    this.mf.total = rd.total;
                    this.mf.del = d;
                    this.tableDatas = rd.records;
                    this.dialogVisible = true;
                })
            },
            //关闭弹出框
            handleClose(v) {
                this.mf.changeNode = '';
                this.mf.loudId = '';
                this.mf.del = '';
                v()
            },
            changejiedian(value,row){
                row.obj['id'] = row['id']
                row.obj[value] = row[value]
            },
            timeSelect1() {
                if (this.timeValue1) {
                    this.formInline.ldateBegin = this.timeValue1[0];
                    this.formInline.ldateEnd = this.timeValue1[1];
                } else {
                    this.formInline.ldateBegin = '';
                    this.formInline.ldateEnd = '';
                }
            },
            timeSelect2() {
                if (this.timeValue2) {
                    this.formInline.expectConvertDateBegin = this.timeValue2[0];
                    this.formInline.expectConvertDateEnd = this.timeValue2[1];
                } else {
                    this.formInline.expectConvertDateBegin = '';
                    this.formInline.expectConvertDateEnd = '';
                }

            },
            timeSelect3() {
                if (this.timeValue3) {
                    this.formInline.expConvDateBegin = this.timeValue3[0];
                    this.formInline.expConvDateEnd = this.timeValue3[1];
                } else {
                    this.formInline.expConvDateBegin = '';
                    this.formInline.expConvDateEnd = '';
                }
            },
            changeNum(value,row) {
                let sNum = row.price.toString(); //先转换成字符串类型
                if (sNum.indexOf('.') == 0) {//第一位就是 .
                    sNum = '0' + sNum
                }
                sNum = sNum.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
                sNum = sNum.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                sNum = sNum.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                sNum = sNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                if (sNum.indexOf(".") < 0 && sNum != "") {
                    sNum = parseFloat(sNum);
                }
                row.obj['id'] = row['id']
                row.obj[value] = row[value]
                row.price = sNum;
            },
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            //明细导出
            exportExcel() {
                this.formInline.idlist = [];
                if (this.multipleSelection && this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.formInline.idlist.push(element.id);
                    });
                }
                updownfile.down("/api/swyl/v1/demo/loudXin/downloadExcel",this.formInline,"post",'data');
            },
            getYMDDate(){
                const now = new Date()
                return [now.getFullYear(),
                    now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1,
                    now.getDate() <10?'0'+now.getDate() : now.getDate()
                ].join('-');
            },
            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                }
            },
            tablemouseenter(row){
                if(row.color == 2 && row.status == 1){
                    this.show = true;
                }
            },
            tablemouseleave(){
                this.show = false;
            },
            handleClickdel(index, rows,v){
                this.$msg.confirm("确认删除?", () => {
                    rows.splice(index, 1);
                    ss.loud.deleteData(v).then(rd => {
                        this.$msg.msgs(rd.msg);
                    })
                })
            },
            uploadExcelFilecallback() {
                this.query();
            },
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            query() {
                this.userRole = this._user.roles;
                console.log("1111111111111",this.userRole)
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_guanhgly" || item.id == "swyl_admin" || item.id == "swyl_lougly") {
                        this.showArea = true;
                        this.a = 1;
                    }
                })
                ss.loud.selectPage(this.formInline).then(rd => {
                    if(rd.records && rd.records.length > 0){
                        for(var i = 0; i < rd.records.length; i++){
                            rd.records[i].obj = [];
                            rd.records[i].maps = [];
                            if (rd.records[i].area == '270') {
                                rd.records[i].area = '250'
                            }
                            if (rd.records[i].area == '300') {
                                rd.records[i].area = '230'
                            }
                            if (rd.records[i].area == '280') {
                                rd.records[i].area = '260'
                            }
                        }
                    }
                    this.tableData = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                ss.loud.selectPage(this.formInline).then(rd => {
                    if(rd.records && rd.records.length>0){
                        for(var i= 0;i<rd.records.length;i++){
                            rd.records[i].obj = [];
                            rd.records[i].maps = [];
                            if (rd.records[i].area == '270') {
                                rd.records[i].area = '250'
                            }
                            if (rd.records[i].area == '300') {
                                rd.records[i].area = '230'
                            }
                            if (rd.records[i].area == '280') {
                                rd.records[i].area = '260'
                            }
                        }
                    }
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFanye() {
                ss.loud.selectPage(this.formInline).then(rd => {
                    if(rd.records && rd.records.length>0){
                        for(var i= 0;i<rd.records.length;i++){
                            rd.records[i].obj = [];
                            rd.records[i].maps = [];
                            if (rd.records[i].area == '270') {
                                rd.records[i].area = '250'
                            }
                            if (rd.records[i].area == '300') {
                                rd.records[i].area = '230'
                            }
                            if (rd.records[i].area == '280') {
                                rd.records[i].area = '260'
                            }
                        }
                    }
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            resetData() {
                this.formInline.statusR = '';
                this.timeValue1 = '';
                this.formInline.ldateBegin = '';
                this.formInline.ldateEnd = '';
                this.timeValue2 = '';
                this.formInline.expectConvertDateBegin = '';
                this.formInline.expectConvertDateEnd = '';
                this.timeValue3 = '';
                this.formInline.expConvDateBegin = '';
                this.formInline.expConvDateEnd = '';
                this.formInline.area = '';
				this.formInline.productModel = '';
				this.formInline.remark = '';
                this.formInline.supplement = '';
                this.formInline.dbBrand = '';
                this.formInline.merchandier = '';
                this.formInline.whetherContactor = '';
                this.formInline.messageType = '';
                this.formInline.customerChannel = '';
                this.formInline.chainGroup = '';
                this.formInline.customerName = '';
                this.formInline.projectName = '';
                this.formInline.partner = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.query();
            },
            saveTo() {
                var t = 1;
                if (this.tableData.length == 0) {
                    this.$msg.msge("请不要保存空数据!");
                    t = 2;
                }
                if (t == 1) {
                    for(var i = 0; i < this.tableData.length; i++){
                        for(var key in this.tableData[i].obj){
                            this.tableData[i].maps.push(key+ ':' +this.tableData[i].obj[key])
                        }
                    }
                    ss.loud.saveUpdate(this.tableData).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    })
                }
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    var t = 1;
                    if (this.tableData.length == 0) {
                        this.$msg.msge("请不要提交空数据!");
                        t = 2;
                    }
                    if (t == 1) {
                        for(var i = 0; i < this.tableData.length; i++){
                            for(var key in this.tableData[i].obj){
                                this.tableData[i].maps.push(key+ ':' +this.tableData[i].obj[key])
                            }
                        }
                        ss.loud.subData(this.tableData).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        })
                    }
                })
            },
            renovate() {
                this.query();
            },
			closeIt() {
			    this.showOrhide = false;
			    if (this.checked) {
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						this.showOrhide = false;
					})
			    }
			},
			nextStep(i) {
			    if (this.status == 1) {
			        if (this.checked) {
			            ss.salesList.toshow(this.toshow,this.checked).then(rd => {
			            	this.showOrhide = false;
			            })
			        } else {
			            ss.salesList.toshow(this.toshow,this.checked).then(rd => {
			            	this.showOrhide = false;
			            })
			        }
			    }
			}
        }
    }
</script>
<style>
    .smTabless .el-table tbody td .cell {
        padding-top: 0;
        padding-bottom: 0;
    }
	
	.smTabless .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	
	.smTabless .el-input__suffix-inner .el-input__icon{
		line-height: 20px;
	}

    .el-table thead.is-group th {
        background-color: #57aefe;
    }
    .yh-red .el-input__inner{
        color: #ff7875;
    }
    .yhtabRed.h-tableInput .el-input__inner{
        color: #ff7875;
    }
    .yhtabOrange.h-tableInput .el-input__inner{
        color: #ffc069;
    }
    .yhtabYellow.h-tableInput .el-input__inner{
        background: #fffb8f;
    }
    .yhtabPink.h-tableInput .el-input__inner{
        color: pink;
    }
    .yhtabGreen.h-tableInput .el-input__inner{
        background: greenyellow;
    }
    .yhtabGreen{
        background: greenyellow;
    }
    .yhtabPink{
        color: pink;
    }
    .yhtabYellow{
        background: #fffb8f;
    }
    .yhtabOrange{
        color: #ffc069;
    }
    .yhtabRed{
        color: #ff7875;
    }
	.yhelformitem .el-form-item__label{
		width: 34%;
	}
	.yhelformitem .el-form-item__content{
		width: 66%;
	}
	.ljjstylepicker .el-date-editor .el-range-separator{
		line-height: 0.35rem;
		width: 10%;
	}
	.w-content .el-button--text {
		color: #1C84C6;
	}
</style>
<style scoped>
	.smTabless .h-tableInput{
		margin-top: 0.05rem;
	}
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
		z-index: 999999;
    }

    .newtext{
    	font-size: 0.28rem;
    	color: white;
    	position: absolute;
    	top:0.2rem;
    	left: 50%;
    	transform: translateX(-50%);
    	font-weight: bold;
    	text-shadow:1px 1px 4px #2785E7;
    	z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
    }

    .leaderbg {
        width: 100%;
        height: 100%;
    }

    .steps {
        position: absolute;
        z-index: 1;
    }

    .step1 {
        top: -0.7rem;
        left: 0;
    }


    .stepbtn {
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #FFFFFF;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.65rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }

    .closeIt {
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        cursor: pointer;
		z-index: 2;
    }
</style>
